// components/voice/VoiceStatusIndicator.tsx
import { Wrench, User } from 'lucide-react';
import { ConnectionState, AgentInfo } from '../../contexts/voice/types';

interface VoiceStatusIndicatorProps {
  state: ConnectionState;
  currentAgent: AgentInfo;
  statusText: string;
  className?: string;
}

export function VoiceStatusIndicator({
  state,
  currentAgent,
  statusText,
  className = '',
}: VoiceStatusIndicatorProps) {
  if (state === 'disconnected') {
    return null;
  }

  return (
    <div className={`bg-card/95 backdrop-blur-sm border border-primary/20 rounded-full px-4 py-2 shadow-lg animate-fade-in flex items-center gap-2 ${className}`}>
      <div className={`w-6 h-6 rounded-full flex items-center justify-center ${
        currentAgent.type === 'human' ? 'bg-green-500' : 'bg-primary'
      }`}>
        {currentAgent.type === 'human' ? (
          <User className="w-3 h-3 text-white" />
        ) : (
          <Wrench className="w-3 h-3 text-white" />
        )}
      </div>
      <div>
        <span className="text-sm font-medium text-foreground">{currentAgent.name}</span>
        <span className="text-xs text-muted-foreground ml-1">- {statusText}</span>
      </div>
    </div>
  );
}
